import Button from '@atlaskit/button/standard-button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { Icon } from '@css-xp/base';
import React from 'react';

import './warning-dialog.scss';

export const WarningDialog = ({
  isOpen,
  onClose,
  onConfirm,
  header,
  description,
  okLabel,
  testId,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  header: string;
  description: React.ReactElement;
  okLabel: string;
  testId?: string;
}) => {
  return (
    <ModalTransition>
      {isOpen && (
        <Modal onClose={onClose} testId={`linkedEnts-warning-modal-dailog-${testId ?? ''}`}>
          <ModalHeader>
            <ModalTitle>
              <Icon type="warning" /> <span className="warning-confirm-header">{header}</span>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div>{description}</div>
          </ModalBody>
          <ModalFooter>
            <div id="warning-confirm-footer">
              <Button appearance="subtle" onClick={onClose} className="cancel-button" testId="cancel-warning-dialog">
                Cancel
              </Button>
              <Button appearance="warning" onClick={onConfirm} autoFocus testId="change-warning-dialog">
                {okLabel}
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};

export default WarningDialog;
